import React, { useState } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';

const LastQuestion = () => {
    const [openQuestion, setOpenQuestion] = useState(null);

    const questions = [
        {
            question: "When will my gummies arrive?",
            answer: "We're fast! Orders typically ship within 24 hours and on average arrive 2 days later. You could be snacking on these delicious gummies and enjoying improved health just 3 days from now."
        },
        {
            question: "What's inside each order? What am I getting?",
            answer: "All of our gummies ship in a larger 8.5\" x 10\" pouch that contains 28 daily sachets. Sachet is a fancy word for snack pack. Our snack packs each contain 8 gummies for you to enjoy daily. So if you're ordering for yourself, you'll get 28 daily snack packs inside a larger pouch. We recommend ordering on subscription. You get better pricing, and we'll make sure you're always stocked up on your healthiest habit."
        },
        {
            question: "When will I feel something?",
            answer: "The timeline for experiencing the benefits of Grüns can vary from person to person. Some individuals may notice improvements within days or weeks, while for others, it may be more gradual. Consistent daily use is essential for the best results."
        },
        {
            question: "How do you handle returns or exchanges?",
            answer: "We want you to have the best experience with Grüns. Returns rarely happen, but we do have a great policy in place. You can return any unopened daily snack packs within 30 days of your first order for a refund or exchange. For all refund requests, you will receive the full value of your order (less $5 return shipping). Submitting a return takes about a minute and we accept all returns in policy. No questions asked. If you have specific questions for your returns or exchange circumstance, our team of Grüns Care Bears are eager to help! You can reach them at support@gruns.co. This policy applies only to your initial purchase."
        }
    ];

    const toggleQuestion = (index) => {
        setOpenQuestion(openQuestion === index ? null : index);
    };

    return (
        <div className="bg-[#dfefe7] py-8 md:py-16">
            <div className="container-custom">
                <div className="flex flex-col md:flex-row justify-between gap-8">
                    <div>
                        <h2 className="text-[#00582d] text-[22px] md:text-4xl font-semibold mb-4">Any last questions?</h2>
                        <div className="relative inline-block">
                            <div className="absolute top-[7px] left-[5px] w-full h-full bg-[#000] rounded-full"></div>
                            <button className="relative bg-[#008037] border border-[#000] text-white font-semibold py-3 md:py-4 px-6 rounded-full hover:translate-y-[1px] hover:translate-x-[1px] transition-transform duration-200 text-sm">
                                No? Try grüns now →
                            </button>
                        </div>
                       
                    </div>
                    <div className="w-full md:w-7/12">
                        {questions.map((item, index) => (
                            <div key={index} className="border-b border-black">
                                <button
                                    className="w-full py-3 flex justify-between items-center text-left"
                                    onClick={() => toggleQuestion(index)}
                                >
                                    <span className=" font-medium  text-black">{item.question}</span>
                                    <MdKeyboardArrowDown
                                        size={24}
                                        className={`text-[black] transition-transform ${openQuestion === index ? 'rotate-180' : ''
                                            }`}
                                    />
                                </button>
                                {openQuestion === index && (
                                    <div className="pb-6 pl-2 text-gray-900 text-xs">
                                        {item.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LastQuestion;
